<template>
  <div
    v-if="spot.gotFixed"
    class="flex flex-col gap-2 items-center bg-theme-primary p-3"
  >
    <h2 class="text-black text-center">
      {{ $t('spotdetail.spot_got_fixed_title') }}
    </h2>
    <div v-if="loggedIn" class="flex items-center gap-2">
      <ButtonHeart
        :liked="spot.userData?.likedFix"
        :loading="likeFixLoading"
        :error="likeFixError"
        @click="likeFix"
        class="cursor-pointer"
      />
      <p class="text-4xl font-semibold">{{ numberOfFixedLikes }}</p>
    </div>
    <div v-else class="relative">
      <IconHeart :liked="false" />
      <p class="text-3xl font-semibold absolute text-center top-2 w-full">{{ numberOfFixedLikes }}</p>
    </div>
    <div
      v-if="spot.userData?.openFixApproval"
      class="flex flex-col gap-3 px-3 mb-2"
    >
      <p>{{ $t('spotdetail.spot_got_fixed_owner_info') }}</p>
      <div class="flex gap-2 w-full">
        <div class="w-full flex flex-col gap-1">
          <ButtonSubmit
            color="white"
            :title="t('spotdetail.spot_got_fixed_approve_button_title')"
            class="w-full"
            @click="approveFix(true)"
            :loading="approveFixLoading"
            :error="approveFixError"
          />
          <p>{{ $t('spotdetail.spot_got_fixed_approve_explanation') }}</p>
        </div>
        <div class="w-full flex flex-col gap-1">
          <ButtonSubmit
            color="white"
            :title="t('spotdetail.spot_got_fixed_disapprove_button_title')"
            class="w-full"
            @click="approveFix(false)"
            :loading="disapproveFixLoading"
            :error="disapproveFixError"
          />
          <p>
            {{ $t('spotdetail.spot_got_fixed_disapprove_explanation') }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="!spot.userData?.openFixApproval && !spotHasImageThatShowsFix" class="flex flex-col gap-2 justify-center mt-2">
      <h3 class="text-center">{{ $t('spotdetail.spot_got_fixed_missing_image_title') }}</h3>
      <div class="flex justify-center">
        <ButtonBlack
          class="flex-grow-0"
          onclick="add_got_fixed_image_modal.showModal()">{{ $t('spotdetail.spot_got_fixed_missing_image_button_title') }}
        </ButtonBlack>
        <Modal id="add_got_fixed_image_modal">
          <div class="flex flex-col gap-2">
            <h2>{{ $t('spotdetail.add_image_title') }}</h2>
            <SpotDetailsAddImage :spot="spot"
                                 name="add-got-fixed-image"
                                 @success="closeAddImageModal()" />
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp()

const { t } = useI18n();
const props = defineProps<{
  spot: SpotDetail
}>();
const { loggedIn} = useUserSession();


const likeFixLoading = ref(false);
const likeFixError = ref(false);
const numberOfFixedLikes = ref(props.spot.numberOfFixedLikes);

const approveFixLoading = ref(false);
const approveFixError = ref(false);

const disapproveFixLoading = ref(false);
const disapproveFixError = ref(false);

const spotHasImageThatShowsFix = computed(() => {
  return props.spot.gallery.some((image: SpotDetailImage) => {
    return image.showsFix;
  });
});

function closeAddImageModal() {
  (document.getElementById('add_got_fixed_image_modal') as HTMLFormElement).close();
}

function likeFix() {

  likeFixError.value = false;
  likeFixLoading.value = true;


  if (props.spot.userData?.likedFix) {
    $api<number>('spots/' + props.spot.id + '/unlikeFix', { method: 'POST' })
      .then((result) => {
        numberOfFixedLikes.value -= result;
        props.spot.numberOfFixedLikes = result;
        if (props.spot.userData) {
          props.spot.userData.likedFix = false;
        }
        likeFixLoading.value = false;
      })
      .catch((theError) => {
        likeFixError.value = true;
        likeFixLoading.value = false;
        console.log(theError);
      });

  } else {
    $api<number>('spots/' + props.spot.id + '/likeFix', { method: 'POST' })
      .then((result) => {
        numberOfFixedLikes.value += result;
        props.spot.numberOfFixedLikes = result;
        if (props.spot.userData) {
          props.spot.userData.likedFix = true;
        }
        likeFixLoading.value = false;
      })
      .catch((theError) => {
        likeFixError.value = true;
        likeFixLoading.value = false;
        console.log(theError);
      });
  }


}

function approveFix(approve: boolean) {
  if (approve) {
    approveFixError.value = false;
    approveFixLoading.value = true;
  } else {
    disapproveFixError.value = false;
    disapproveFixLoading.value = true;
  }

  const formData = new FormData();
  formData.append('approve', approve.toString());

  $api<boolean>('spots/' + props.spot.id + '/approveFix', { method: 'POST', body: formData})
    .then((result) => {
      if (props.spot.userData) {
        props.spot.userData.openFixApproval = false;
        props.spot.gotFixed = result;
      }
      if (!approve) {
        props.spot.gallery.forEach((image: SpotDetailImage) => {
          image.ownerApprovesFix = false;
        });
      }
    })
    .catch((theError) => {
      if (approve) {
        approveFixError.value = true;
      } else {
        disapproveFixError.value = true;
      }
    })
    .finally(() => {
      if (approve) {
        approveFixLoading.value = false;
      } else {
        disapproveFixLoading.value = false;
      }
    });
}
</script>
